import * as React from "react";

import NotFoundPage from "./Page"


export const NotFoundRoutes = {
    path: "*",
    element: <NotFoundPage />,
    notRender: true,
    hideInHome: true,
}